import {
    Button,
  Layout,
  Space,
  Typography,
} from 'antd';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import DataTable, { DataTableColumnProps } from '../../shared/DataTable/DataTable';
import DataTableButtonUtil from '../../shared/DataTable/DataTableButtonUtil';
import PfdReportsDTO from '../../../models/PfdReportsDTO';
import DataTableColumnUtil from '../../shared/DataTable/DataTableColumnUtil';
import PublicReportsApiService from '../../../api/PublicReportsApiService';
import HistoryUtil from '../../../utils/HistoryUtil';
import Routes from '../../../consts/Routes';
import { ArrowLeftOutlined } from '@ant-design/icons';
import DataTableCellRendererUtil from '../../shared/DataTable/DataTableCellRendererUtil';

const { Content } = Layout;

interface PfdReportsProps {

}

interface PfdReportsState {
  tableColumns: DataTableColumnProps<PfdReportsDTO>[];
}

class PfdReports extends React.Component<RouteComponentProps<PfdReportsProps>, PfdReportsState> {

  constructor(props: RouteComponentProps<PfdReportsProps>) {
    super(props);

    this.state = {
      tableColumns: this.getTableColumns()
    };
  }

  render() {
    const actionButtons = [];
    actionButtons.push(DataTableButtonUtil.Reset());
    return (
      <Content className="content-pad">
        <DataTable
          globalSearch={true}
          serverSide={true}
          buttonBar={actionButtons}
          columns={this.state.tableColumns}
          tableProps={{
            rowKey: 'fileName',
            sortDirections: ['ascend', 'descend'],
            locale: { emptyText: 'No Reports Currently Match Your Filter' }
          }}
          fetchData={{
            fetch: function (tableRequest) {
              return PublicReportsApiService.getPfdReports(tableRequest)
                .then(res => {
                  return res;
                });
            },
            failureMessage: 'Failed to retrieve public reports'
          }}
          styleOptions={{ compact: true, alternatingRowHighlight: true }}
          title={
            <Button type="link" onClick={() => HistoryUtil.push(Routes.generate(Routes.PUBLIC_REPORTS))}>
              <Typography.Title level={4}>
                <Space size="large">
                  <ArrowLeftOutlined className="public-report-links"/> Personal Financial Disclosures
                </Space>
              </Typography.Title>
            </Button>
          }
        />
      </Content>
    );
  }

  private getTableColumns = (): DataTableColumnProps<PfdReportsDTO>[] => {
    const generatedOn = DataTableColumnUtil.Date<PfdReportsDTO>('Filed On', 'filedOn');
    generatedOn.render = DataTableCellRendererUtil.ShortDate;
    return [
      DataTableColumnUtil.Text('Covered Year', 'coveredYear', null, { defaultSortOrder: 'descend' }),
      DataTableColumnUtil.Text('First Name', 'contactFirstName'),
      DataTableColumnUtil.Text('Last Name', 'contactLastName'),
      DataTableColumnUtil.Text('Agency/Department', 'stateAgency'),
      DataTableColumnUtil.Text('Division/Department', 'division'),
      DataTableColumnUtil.Text('Contact Type', 'contactType'),
      generatedOn,
      DataTableColumnUtil.Text('Filing Status', 'filingStatus'),
      DataTableColumnUtil.Buttons('fileName',
        [
          { text: 'View', onClick: (rowData) => window.open(rowData.fileUrl || '') },
        ])
    ];
  }
}

export default PfdReports;